var Morescroll = function(options) {
  // check data
  if (! (options.el instanceof Element)) return false;
  // import data
  var 
    el = options.el,
    onOverScroll 
      = typeof options.onOverScroll == 'function' 
      ? options.onOverScroll 
      : function(){},
    onScrollBottom 
      = typeof options.onScrollBottom == 'function' 
      ? options.onScrollBottom 
      : function(){};
      
  // private data
  var
    pullStart = null,
    pullDelta = null,
  
    startPull = function(e) {
      if (el.scrollTop <= 0)
        pullStart = e.touches[0].clientY
    },
    onPull = function(e) {
      if (pullStart)
        pullDelta = e.touches[0].clientY - pullStart;
    },
    endPull = function() {
      if (pullStart && pullDelta > 120)
        onOverScroll()

      pullStart = null;
      pullDelta = null;
    },
    onScroll = function(e) {
      let scrollBottom = e.target.scrollTop + e.target.offsetHeight;
      if (scrollBottom == e.target.scrollHeight)
        onScrollBottom();
    };

  function init() {
    document.body.addEventListener('touchstart', startPull);
    document.body.addEventListener('touchmove', onPull);
    document.body.addEventListener('touchend', endPull);

    el.addEventListener('scroll', onScroll);
  }
  init();

  // public data
  return {
    destroy: function() {
      document.body.removeEventListener('touchstart', startPull);
      document.body.removeEventListener('touchmove', onPull);
      document.body.removeEventListener('touchend', endPull);
      el.removeEventListener('scroll', onScroll);
    }
  }
}
export default Morescroll;